import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Container, Box } from '@mui/material';

import CustomerLogin from './CustomerLogin';

// Route guard for customer-only pages: anonymous visitors get the login
// panel in place (mirrors HasCallRequestRoute / HasCallRoute). If they
// arrived anonymous and just logged in from this gate, land them on home —
// unless `stayAfterLogin` (carrito / checkout: the page they asked for is
// exactly where they want to be once logged in).
const HasCustomerRoute = ({ customer, children, stayAfterLogin }) => {
    const arrivedAnonymous = useRef(!customer);

    if (!customer) {
        return (
            <Container maxWidth="md" sx={{ py: 4 }}>
                <Box sx={{ mt: 4 }}>
                    <CustomerLogin />
                </Box>
            </Container>
        );
    }

    if (arrivedAnonymous.current && !stayAfterLogin) {
        return <Navigate to="/home" replace />;
    }

    return children;
};

const mapStateToProps = (state) => {
    return {
        customer: state.customer.customer,
    };
};

export default connect(mapStateToProps)(HasCustomerRoute);
